import { defineNuxtPlugin } from 'nuxt/app';
import { smoothScrollbarDirective } from '@app/directives/smoothScrollbar';

export default defineNuxtPlugin((nuxtApp) => {
	nuxtApp.vueApp.directive('scrollbar', smoothScrollbarDirective);
});
